import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { clientsData } from "../Data";

const slides = [
  { src: "/img/slider1.jpg", alt: "slide1" },
  { src: "/img/gall555.jpg", alt: "slide3" },
  { src: "/img/gall56.webp", alt: "slide2" },
];

export const HomeSlider = () => {
  const mainSliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  };

  // Modal slider settings
  const modalSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    initialSlide: 0,
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalStartIndex, setModalStartIndex] = useState(0);
  const modalSliderRef = useRef(null);

  const openModal = (index) => {
    setModalStartIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // To sync the modal slider to start at clicked slide
  React.useEffect(() => {
    if (modalSliderRef.current && isModalOpen) {
      modalSliderRef.current.slickGoTo(modalStartIndex, true);
    }
  }, [modalStartIndex, isModalOpen]);

  return (
    <>
      <div className="w-full m-0 overflow-hidden">
        <Slider {...mainSliderSettings}>
          {slides.map((slide, idx) => (
            <div
              key={idx}
              className="relative cursor-pointer"
              onClick={() => openModal(idx)}
            >
              <img src={slide.src} alt={slide.alt} className="w-full" />
              <div
                className="absolute bottom-0 left-0 right-0 top-0 h-full w-full bg-black bg-opacity-40 flex items-center justify-center text-white"
                style={{ transition: "background-color 0.3s" }}
              ></div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80"
          onClick={closeModal}
        >
          <div
            className="relative max-w-4xl w-full mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-white text-3xl font-bold hover:text-gray-400"
              aria-label="Close modal"
            >
              &times;
            </button>

            <Slider
              {...modalSliderSettings}
              initialSlide={modalStartIndex}
              ref={modalSliderRef}
            >
              {slides.map((slide, idx) => (
                <div key={idx} className="flex justify-center">
                  <img
                    src={slide.src}
                    alt={slide.alt}
                    className="max-h-[80vh] object-contain"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
};

const CustomArrow = ({ className, style, onClick, direction }) => {
  return (
    <button
      className={`absolute top-1/2 z-20 -translate-y-1/2 bg-white bg-opacity-75 rounded-full p-2 shadow-md hover:bg-opacity-100 focus:outline-none ${
        direction === "left" ? "left-2" : "right-2"
      }`}
      style={{ ...style }}
      onClick={onClick}
      aria-label={`${direction} arrow`}
    >
      {direction === "left" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-gray-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-gray-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      )}
    </button>
  );
};

export const ClientSlider = () => {
  const settings = {
    dots: false, // Disable dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 4, // Number of slides visible at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay speed in ms
    nextArrow: <CustomArrow direction="right" />, // Custom right arrow
    prevArrow: <CustomArrow direction="left" />, // Custom left arrow
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="">
      <div className="py-8 lg:py-16 mx-auto max-w-screen-xl px-4">
        <h2 className="font-extrabold mt-5 mb-10 uppercase leading-snug text-center text-blue-400 py-3 text-3xl md:text-4xl font-teko">
          Our Prestigious Clients
        </h2>

        <Slider {...settings} className="text-gray-400 gap-y-6">
          {clientsData.map((client) => (
            <div
              key={client.id}
              className="flex justify-center items-center flex-col gap-4"
            >
              <img
                src={client.imageSrc}
                alt={`client${client.id}`} // Fixed the alt attribute
                className="h-48 w-[90%] object-contain border-2 border-gray-300 rounded-md px-5 mx-2" // Added mx-2 for left and right gap
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};
